export const navMenuItems = [
  { title: "home", url: "home" },
  { title: "ourService", url: "our-service" },
  { title: "howToStart", url: "how-to-start" },
  { title: "whyWe", url: "why-we" },
  { title: "FAQ", url: "qa" },
  { title: "contact", url: "contact" },
];
